import React, { Component } from "react";
import { Modal } from "reactstrap";

class PetRemove extends Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onCancel() {
    this.props.onCancel();
  }

  onSubmit(pet) {
    this.props.onSubmit(pet);
    this.props.onCancel();
  }

  render() {
    return (
      <Modal isOpen={this.props.isRemoveModalOpen} toggle={this.onCancel}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Премахни домашен любимец
          </h5>
          <button
            type="button"
            onClick={this.onCancel}
            className="close"
            data-dismiss="modal"
            aria-label="Затвори"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5>Сигурни ли сте, че искате да премахнете този домашен любимец?</h5>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={this.onCancel}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            Отказ
          </button>
          <button
            type="button"
            onClick={() => { this.onSubmit(this.props.data._id) }}
            className="btn btn-danger waves-effect waves-light"
          >
            Да
          </button>
        </div>
      </Modal>
    );
  }
}

export default PetRemove;
